import * as actionTypes from '../actions/actionTypes';
import {updateObject} from "../../shared/utility";
import {PanelTabs} from '../actions/dashboard';
import {cloneObject} from '../../shared/utility';

const defaultTabState = {
    expanded: false
}

const initialState = {
    activePanelTab: null,
    [PanelTabs.my_vehicle]: cloneObject(defaultTabState),
    [PanelTabs.offers]: cloneObject(defaultTabState),
    [PanelTabs.appointments]: cloneObject(defaultTabState)
}

// const setActivePanelTab = (state, action) => {
//     return updateObject(state, {
//         activePanelTab: action.tab
//     });
// }

// const resetActivePanelTab = (state, action) => {
//     return updateObject(state, {
//         activePanelTab: null
//     })
// }

const updatePanelTab = (state, action) => {
    return updateObject(state, {
        [action.tab]: updateObject(state[action.tab], {
            expanded: !!action.expanded
        })
    })
}

const expandAllTabs = (state, action) => {
    for(let idx in PanelTabs) {
        state = updatePanelTab(state, {
            tab: idx,
            expanded: action.expanded
        })
    }

    return state;
}

const expandTabOnly = (state, action) => {
    state = expandAllTabs(state, { expanded: false });
    return updatePanelTab(state, {
        tab: action.tab,
        expanded: true
    });
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        // case actionTypes.SET_ACTIVE_PANEL_TAB:
        //     return setActivePanelTab(state, action);
        // case actionTypes.RESET_ACTIVE_PANEL_TAB:
        //     return resetActivePanelTab(state, action);

        case actionTypes.UPDATE_PANEL_TAB:
            return updatePanelTab(state, action);    
        case actionTypes.EXPAND_ALL_TABS:
            return expandAllTabs(state, action);   
        case actionTypes.EXPAND_TAB_ONLY:
            return expandTabOnly(state, action);     
        default:
            return state;
    }
};

export default reducer;